import Helper from '@ember/component/helper';

import { service } from '@ember/service';

export default class RegisterUrlHelper extends Helper {
  @service urlRegister;

  compute([ ctx, url ]) {
    return () => this.urlRegister.register(ctx, url);
  }
}
